/* MKT-067 — NV guided-build product layout.
   Owns: step collapse/expand, chip/swatch proxies onto the theme's real option
   inputs, summary + sticky-bar mirroring, DPO placement + fail-safe.
   Never owns: the price (mirrored from the node the theme/DPO app writes),
   the DPO markup (moved at most, never cloned or rewritten), the cart submit. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-nv-product-build]');
    if (!root) return;

    var dataEl = root.querySelector('[data-nv-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { options: [], variants: [], dims: {}, sectionSizes: [], dpoTimeoutMs: 6000 }; }

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-nv-step]'));
    var formwrap = root.querySelector('[data-nv-formwrap]');
    var priceUI = root.querySelector('[data-price-ui]');
    var sticky = root.querySelector('[data-nv-sticky]');
    var specStep = root.querySelector('[data-nv-step-spec]');

    /* ---------- helpers ---------- */

    // dims entries come in two shapes: the legacy hard-coded string
    // ("55cm h × 47cm w") or the MKT-083 metafield object ({h, w, split}).
    function dimEntry(size) {
      var d = (data.dims || {})[size];
      if (!d) return null;
      if (typeof d === 'string') return { text: d, split: (data.sectionSizes || []).indexOf(size) >= 0 };
      return { text: d.h + 'cm h × ' + d.w + 'cm w', split: !!d.split || (data.sectionSizes || []).indexOf(size) >= 0 };
    }

    function prettyName(v) {
      // "WarmWhite" -> "Warm White"; strip DPO's generic-variant token ("50cm (D#XXXXXXX)" -> "50cm")
      return String(v).replace(/\s*\(D#[^)]*\)/gi, '').replace(/([a-z])([A-Z])/g, '$1 $2');
    }

    function formatMoney(cents) {
      var format = data.moneyFormat || '£{{amount}}';
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var thousands = amount.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var rest = amount.indexOf('.') >= 0 ? '.' + amount.split('.')[1] : '';
      return format.replace(/\{\{\s*amount[^}]*\}\}/, thousands + rest);
    }

    // Current choice per option position, seeded from the theme's checked radios/selects.
    var chosen = {};

    function nativeControlsFor(pos) {
      if (!formwrap) return [];
      var idx = pos - 1;
      var radios = formwrap.querySelectorAll('input[type="radio"][name="option-' + idx + '"]');
      if (radios.length) return Array.prototype.slice.call(radios);
      var sel = formwrap.querySelector('[data-variant-option][data-variant-option-index="' + idx + '"] select, select[data-variant-option][data-variant-option-index="' + idx + '"]');
      return sel ? [sel] : [];
    }

    function readNativeChoice(pos) {
      var controls = nativeControlsFor(pos);
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        if (c.type === 'radio') { if (c.checked) return c.value; }
        else if (c.value && c.value !== 'not-selected') return c.value;
      }
      return null;
    }

    function writeNativeChoice(pos, value) {
      var controls = nativeControlsFor(pos);
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        // MKT-109: dispatch even when the value is already selected — a shopper re-clicking
        // their size must emit a real event (it is the recovery the guard message asks for,
        // and DPO's one-behind cache only advances on events).
        if (c.type === 'radio') {
          if (c.value === value) {
            if (!c.checked) c.checked = true;
            c.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          if (c.value !== value) c.value = value;
          c.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function currentVariant() {
      var vs = data.variants || [];
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i], match = true;
        for (var p = 1; p <= (data.options || []).length; p++) {
          if (chosen[p] && v.options[p - 1] !== chosen[p]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* ---------- MKT-099 Branch B: one colour, not two ----------
       RGB colour-changing is modelled twice: never in Shopify (0 of 1,965 products carry an
       RGB Color value — measured 2026-09-01) and as the app's paid Type of LED option. The
       variant therefore always carries a colour name; while the app's colour-changing option
       is selected, step 2 stops asserting that colour — the collapsed value, summary bar and
       sticky bar read "Colour changing (RGB)" and the chosen swatch is visibly superseded.
       Moving to any other colour clears the app option, and the signpost sets it — always
       through the app's OWN control with its own handlers running, so its price updates
       (measured: +30% on, base back off). Display-only reconciliation: the cart's variant
       still names a colour. If the app, its field or its reveal is absent, none of this runs
       and the H3 signpost behaviour (open step 3 + highlight) is the fallback. */
    var RGB_RE = /colou?r\s*chang|\brgb\b/i;
    var RGB_LABEL = 'Colour changing (RGB)';
    var colourGroupEl = root.querySelector('[data-nv-step-kind="colour"] [data-nv-chips]');
    var colourPos = colourGroupEl ? parseInt(colourGroupEl.getAttribute('data-nv-option-pos'), 10) : null;

    function ledSelectInfo() {
      if (!dpoSlot) return null;
      var sels = dpoSlot.querySelectorAll('select');
      for (var i = 0; i < sels.length; i++) {
        for (var j = 0; j < sels[i].options.length; j++) {
          if (RGB_RE.test(sels[i].options[j].text)) return { sel: sels[i], rgbIndex: j };
        }
      }
      return null;
    }

    function rgbActive() {
      var info = ledSelectInfo();
      if (!info) return false;
      var o = info.sel.options[info.sel.selectedIndex];
      return !!(o && RGB_RE.test(o.text));
    }

    // Change the app's own control the way a hand would: value via selectedIndex, then the
    // events its handlers listen for. Never its markup, never its price.
    function appChange(sel, idx) {
      if (sel.selectedIndex === idx) return;
      sel.selectedIndex = idx;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Where "off" lands: the explicit no-surcharge choice (e.g. "Single Colour") if the app
    // offers one, else the first concrete option without a surcharge marker, else option 0.
    function ledDefaultIndex(sel, rgbIndex) {
      for (var j = 0; j < sel.options.length; j++) if (/single\s*colou?r/i.test(sel.options[j].text)) return j;
      for (var k = 0; k < sel.options.length; k++) if (k !== rgbIndex && sel.options[k].value !== '' && sel.options[k].text.indexOf('+') < 0) return k;
      return 0;
    }

    /* ---------- MKT-104 Batch N: one authoritative colour on the order line ----------
       The variant still names a colour when the app's colour-changing option is on
       (Batch M, Branch B — display only). This property says which field wins, in words
       a person on the shop floor reads without cross-referencing. Written in BOTH states,
       always, so its absence is never meaningful. Ours on the theme's product form —
       nothing DPO writes is touched. Wording is Grey's. */
    function syncColourProperty() {
      if (!formwrap || !colourPos || !chosen[colourPos]) return;
      var form = formwrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var input = form.querySelector('input[name="properties[Colour as ordered]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Colour as ordered]';
        form.appendChild(input);
      }
      input.value = rgbActive()
        ? 'Colour changing (RGB) — ignore the variant colour'
        : prettyName(chosen[colourPos]);
    }

    function setLedRgb(on, tries) {
      var info = ledSelectInfo();
      if (!info) return false;
      if (on && (info.sel.disabled || info.sel.offsetParent === null)) {
        // The field sits behind the app's own reveal (a select offering "Other options"):
        // choose that through its control, then wait for the app to enable the field.
        var sels = dpoSlot.querySelectorAll('select'), gate = null, gi = -1;
        Array.prototype.forEach.call(sels, function (s) {
          if (gate || s === info.sel || s.disabled || s.offsetParent === null) return;
          for (var j = 0; j < s.options.length; j++) {
            if (/other options/i.test(s.options[j].text)) { gate = s; gi = j; return; }
          }
        });
        if (gate) appChange(gate, gi);
        if ((tries || 0) < 20) { setTimeout(function () { setLedRgb(on, (tries || 0) + 1); }, 250); return true; }
        return false; // never enabled — the open-and-highlight signpost is the whole action
      }
      appChange(info.sel, on ? info.rgbIndex : ledDefaultIndex(info.sel, info.rgbIndex));
      refreshUI();
      return true;
    }

    /* ---------- steps: collapse / expand ---------- */

    function openStep(step) {
      steps.forEach(function (s) {
        var open = s === step;
        s.classList.toggle('nv-step--open', open);
        var head = s.querySelector('.nv-step__head');
        if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function stepAfter(step) {
      var i = steps.indexOf(step);
      for (var j = i + 1; j < steps.length; j++) {
        if (!steps[j].hidden) return steps[j];
      }
      return null;
    }

    steps.forEach(function (step) {
      var head = step.querySelector('.nv-step__head');
      if (head) head.addEventListener('click', function () {
        if (step.classList.contains('nv-step--open')) return;
        openStep(step);
      });
    });

    function markStepDone(step, answerText) {
      // MKT-093.3: no tick marker — the collapsed row carrying its answer is the completion signal
      step.classList.add('nv-step--done');
      var ans = step.querySelector('[data-nv-step-answer]');
      if (ans && answerText) ans.textContent = answerText;
    }

    /* ---------- chips / swatches ---------- */

    function updateChipStates() {
      steps.forEach(function (step) {
        var group = step.querySelector('[data-nv-chips]');
        if (!group) return;
        var pos = parseInt(group.getAttribute('data-nv-option-pos'), 10);
        var chips = group.querySelectorAll('[data-nv-chip]');
        chips.forEach(function (chip) {
          var on = chip.getAttribute('data-nv-value') === chosen[pos];
          chip.setAttribute('aria-checked', on ? 'true' : 'false');
          chip.tabIndex = on ? 0 : -1;
        });
        if (!group.querySelector('[data-nv-chip][tabindex="0"]') && chips.length) chips[0].tabIndex = 0;
      });
    }

    function refreshUI() {
      // MKT-099: while the app's colour-changing option is on, the colour part of every
      // mirrored answer reads "Colour changing (RGB)" instead of a colour name.
      var rgbOn = rgbActive();
      var parts = [];
      Object.keys(chosen).sort().forEach(function (p) {
        if (chosen[p]) parts.push(rgbOn && colourPos && parseInt(p, 10) === colourPos ? RGB_LABEL : prettyName(chosen[p]));
      });
      var selectionText = parts.join(' · ');

      // step heads — the size step's closed head carries the dimensions too (MKT-080.2)
      steps.forEach(function (step) {
        var group = step.querySelector('[data-nv-chips]');
        if (!group) return;
        var pos = parseInt(group.getAttribute('data-nv-option-pos'), 10);
        if (!chosen[pos]) return;
        var answer = prettyName(chosen[pos]);
        if (rgbOn && colourPos && pos === colourPos) answer = RGB_LABEL;
        if (step.getAttribute('data-nv-step-kind') === 'size') {
          var d = dimEntry(chosen[pos]);
          if (d) answer += ' · ' + d.text;
        }
        markStepDone(step, answer);
      });

      // price meta, summary, sticky
      var metaSel = root.querySelector('[data-nv-meta-selection]');
      if (metaSel) metaSel.textContent = selectionText || ' ';
      var sumSel = root.querySelector('[data-nv-sum-selection]');
      if (sumSel) {
        var spec = specStep && !specStep.hidden ? (specStep.querySelector('[data-nv-step-answer]') || {}).textContent : '';
        sumSel.textContent = selectionText + (spec ? ' · ' + spec : '') || ' ';
      }
      var stickySel = root.querySelector('[data-nv-sticky-selection]');
      if (stickySel) stickySel.textContent = selectionText || ' ';

      // size extras: split-into-pieces notice (dimensions live on the chips, MKT-082.4)
      var sizeStep = root.querySelector('[data-nv-step-kind="size"]');
      if (sizeStep) {
        var pos2 = parseInt(sizeStep.querySelector('[data-nv-chips]').getAttribute('data-nv-option-pos'), 10);
        var size = chosen[pos2];
        var warn = sizeStep.querySelector('[data-nv-warn]');
        if (size && warn) {
          var de = dimEntry(size);
          warn.hidden = !((de && de.split) || (data.sectionSizes || []).indexOf(size) >= 0);
        }
      }

      // MKT-104: the order-line property follows every state change (chip, app field,
      // variant-change, restore) — the value at add time is the final state.
      syncColourProperty();

      // MKT-099: the chosen swatch is visibly superseded and the signpost reads pressed
      root.classList.toggle('nv-pb--rgb', rgbOn);
      var rgbBtn2 = root.querySelector('[data-nv-rgb-link]');
      if (rgbBtn2) rgbBtn2.setAttribute('aria-pressed', rgbOn ? 'true' : 'false');

      updateChipStates();
      mirrorPrice();
    }

    function selectChip(group, chip, advance) {
      var pos = parseInt(group.getAttribute('data-nv-option-pos'), 10);
      chosen[pos] = chip.getAttribute('data-nv-value');
      writeNativeChoice(pos, chosen[pos]);
      // MKT-109 (D5): DPO's cached variant updates one change-event BEHIND (measured: 23/26
      // forward runs priced the +30% from the previous size at 1s AND 5s pace; 15/15 reverse
      // runs dropped the surcharge from the display). A second event on the same control,
      // same value, lands its cache on the truth and its own recalc then prices from the
      // right base (measured: £336.70→£388.70, £439→£570.70). Events on real controls only —
      // the app's arithmetic is never touched.
      // The second event must be SPACED: the app debounces, and two events in one tick
      // collapse into a single pass (measured: same-tick pair failed, +350ms healed).
      // 500ms; latest click wins, and the control is re-resolved at fire time.
      if (dpoReady) {
        if (nvNudgeTimer) clearTimeout(nvNudgeTimer);
        nvNudgeTimer = setTimeout(function () {
          nvNudgeTimer = null;
          var nudge = nativeControlsFor(pos).filter(function (c) { return c.type !== 'radio' || c.checked; })[0];
          if (nudge) nudge.dispatchEvent(new Event('change', { bubbles: true }));
        }, 500);
      }
      // MKT-099: choosing any colour while the app says colour-changing clears the app option
      // through its own control — a shopper moving away from RGB must not silently keep paying 30%.
      if (colourPos && pos === colourPos && rgbActive()) setLedRgb(false);
      refreshUI();
      if (advance) {
        var step = group.closest('[data-nv-step]');
        var next = stepAfter(step);
        if (next) openStep(next);
      }
    }

    root.querySelectorAll('[data-nv-chips]').forEach(function (group) {
      // MKT-082.1 (C1 reinstated): selection leaves the step open — a step collapses
      // only when another step's head is pressed. Nothing closes under the cursor.
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-nv-chip]');
        if (!chip) return;
        selectChip(group, chip, false);
      });

      // arrow keys select in place; Enter/Space deliberately opens the next step
      group.addEventListener('keydown', function (e) {
        var chips = Array.prototype.slice.call(group.querySelectorAll('[data-nv-chip]'));
        var idx = chips.indexOf(document.activeElement);
        if (idx < 0) return;
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) >= 0) {
          e.preventDefault();
          var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
          var nextChip = chips[(idx + dir + chips.length) % chips.length];
          selectChip(group, nextChip, false);
          nextChip.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectChip(group, chips[idx], true);
        }
      });
    });

    /* ---------- price mirroring: the app/theme's number, copied, never computed ---------- */

    function priceText() {
      if (!priceUI) return '';
      var el = priceUI.querySelector('[data-price] .money') || priceUI.querySelector('.money');
      return el ? el.textContent.trim() : '';
    }

    function mirrorPrice() {
      var t = priceText();
      if (!t) return;
      var sumPrice = root.querySelector('[data-nv-sum-price]');
      if (sumPrice) sumPrice.textContent = t;
      var stickyPrice = root.querySelector('[data-nv-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = t;
      syncKlarna();
      checkGuard();
    }

    /* ---------- PRODUCTPAGE-112 (C2): Back leaves the specification on the old choice ----------
       Returning via Back — a bfcache restore, or a full reload where the browser restores
       form values — can bring the app's controls back carrying the old configuration.
       Grey's choice (2026-08-27): reset the Specification to Recommended rather than
       reconstruct. The check runs shortly after pageshow, before a human could have opened
       the collapsed step, through the app's OWN control; on a genuinely fresh page the
       gate already reads Recommended and nothing happens. */
    var nvUserActed = false;
    ['pointerdown', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { nvUserActed = true; }, { capture: true, passive: true });
    });
    function resetSpecToRecommended() {
      if (nvUserActed) return true; // the shopper is already driving — leave the page alone
      if (!dpoSlot) return false;
      var sels = dpoSlot.querySelectorAll('select');
      if (!sels.length) return false;
      for (var i = 0; i < sels.length; i++) {
        var s = sels[i];
        if (s.options.length && /recommended/i.test(s.options[0].text)) {
          if (s.selectedIndex !== 0) appChange(s, 0);
          break;
        }
      }
      (data.options || []).forEach(function (o) {
        var v = readNativeChoice(o.position);
        if (v) chosen[o.position] = v;
      });
      var specAns = specStep && specStep.querySelector('[data-nv-step-answer]');
      var sayRecommended = function () { if (specAns) specAns.textContent = 'Recommended'; };
      sayRecommended(); // our own reset's change event just wrote "Your choices" — this state is Recommended
      refreshUI();
      setTimeout(function () { sayRecommended(); refreshUI(); }, 1200); // the app's recalc lands async; mirror again after it
      return true;
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) nvUserActed = false; // a bfcache restore keeps the JS heap — the old view's clicks are not this view's
      setTimeout(function () {
        // if the app's selects are not rendered yet, one more try — then leave the page alone
        if (!resetSpecToRecommended()) setTimeout(resetSpecToRecommended, 2500);
      }, e.persisted ? 400 : 1500);
    });

    /* ---------- MKT-109 (D5): the surcharge guard ----------
       Measured 2026-09-02, 23/26 forward runs wrong at both 1s and 5s pace: DPO prices the
       +30% display from its own cached variant, which updates one variant-change EVENT
       behind — and after a size change with Colour Changing already on, 15/15 runs dropped
       the surcharge from the display entirely. Add-to-cart charges the CORRECT current-size
       surcharge in every reproduced add, so the display can disagree with what will be
       charged. We never correct the app's number: when the app's total disagrees with the
       page's own current base x the app's STATED multiplier (parsed from its own option
       label), the sale stops — Add to cart disabled with a plain message, the Klarna block
       hidden — until the two agree. Runs only while Colour Changing is the sole priced app
       option; with any other '+' option selected the expected total is the app's own
       composition, which we will not compute. App absent -> rgbActive false -> inert. */
    var nvGuardTimer = null, nvGuardOn = false, nvGuardInterval = null, nvNudgeTimer = null;
    function ledPct() {
      var info = ledSelectInfo();
      if (!info) return null;
      var o = info.sel.options[info.sel.selectedIndex];
      var m = o && o.text.match(/([\d.]+)\s*%/);
      return m ? parseFloat(m[1]) : null;
    }
    function otherPaidSelected() {
      var info = ledSelectInfo();
      if (!dpoSlot || !info) return false;
      var sels = dpoSlot.querySelectorAll('select');
      for (var i = 0; i < sels.length; i++) {
        if (sels[i] === info.sel) continue;
        var o = sels[i].options[sels[i].selectedIndex];
        if (o && o.text.indexOf('+') >= 0) return true;
      }
      return false;
    }
    function surchargeDisagrees() {
      if (!rgbActive() || otherPaidSelected()) return false;
      var pct = ledPct();
      var v = currentVariant();
      var observed = parseMoneyMinor(priceText());
      if (pct === null || !v || observed === null) return false;
      return Math.abs(observed - Math.round(v.price * (1 + pct / 100))) > 1;
    }
    function guardDisableButtons(on) {
      var btns = root.querySelectorAll('.nv-formwrap button[name="add"], [data-nv-sticky-add]');
      Array.prototype.forEach.call(btns, function (b2) { b2.disabled = on; });
    }
    function setGuard(on) {
      if (on === nvGuardOn) return;
      nvGuardOn = on;
      guardDisableButtons(on);
      // The theme's own variant machinery re-enables the button on variant change
      // (measured) — while the guard holds, the disabled state is re-asserted.
      if (on && !nvGuardInterval) nvGuardInterval = setInterval(function () { guardDisableButtons(true); }, 400);
      if (!on && nvGuardInterval) { clearInterval(nvGuardInterval); nvGuardInterval = null; }
      var msg = root.querySelector('[data-nv-guard-msg]');
      if (on && !msg && formwrap && formwrap.parentNode) {
        msg = document.createElement('p');
        msg.setAttribute('data-nv-guard-msg', '');
        msg.setAttribute('role', 'alert');
        msg.className = 'nv-guard-msg';
        msg.textContent = 'The price shown has not updated for your latest change. Re-select your size, or Colour Changing under Type of LED, to refresh it — Add to cart unlocks when the price is right.';
        formwrap.parentNode.insertBefore(msg, formwrap);
      }
      if (msg) msg.hidden = !on;
      var holder = root.querySelector('.nv-pb__klarna');
      if (holder) { if (on) holder.hidden = true; else syncKlarna(); }
    }
    function checkGuard() {
      if (surchargeDisagrees()) {
        // arm, don't flash: the app's own recalc takes ~0.5s and must be allowed to land
        if (!nvGuardTimer) nvGuardTimer = setTimeout(function () {
          nvGuardTimer = null;
          if (surchargeDisagrees()) setGuard(true);
        }, 1500);
      } else {
        if (nvGuardTimer) { clearTimeout(nvGuardTimer); nvGuardTimer = null; }
        setGuard(false);
      }
    }

    /* ---------- MKT-105.1 Batch O: Klarna follows the price ----------
       The app block server-renders data-purchase-amount once (minor units, first
       variant) and never updates it, so the instalment showed a stale amount at
       every size and under the DPO surcharge (punch-list D1, measured). The fix
       carries the DISPLAYED total — the number the theme/DPO wrote, never one we
       compute — into the placement through Klarna's own interface: the
       data-purchase-amount attribute + Klarna.OnsiteMessaging.refresh() (the
       script's own API; the instalment is re-derived by Klarna). Hangs on the same
       state-change funnel as Batch N's property: refreshUI -> mirrorPrice, plus the
       price node's MutationObserver, so DPO's async price writes are carried too.
       If the total cannot be read, the block hides — a missing instalment is
       recoverable, a wrong one is a price claim. */
    function parseMoneyMinor(text) {
      var m = String(text).replace(/,/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
      if (!m) return null;
      return parseInt(m[1], 10) * 100 + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0);
    }
    /* Klarna's own app-block integration re-renders the placement on every variant change
       with the ORIGINAL server-rendered amount (measured: our 43900 was overwritten back to
       25900 — that overwrite is D1's engine). The placement honours the attribute at render
       time, so we keep the desired amount asserted: a MutationObserver on the attribute
       re-applies it when their re-render reverts it. Guarded — re-assert only while the
       attribute disagrees, capped at 8 per pass; if it will not hold, the block is hidden
       rather than left showing a wrong instalment. */
    var nvKlarnaAmount = null;
    var nvKlarnaAsserts = 0;
    var nvKlarnaT0 = Date.now();
    setTimeout(function () { try { syncKlarna(); } catch (e) {} }, 11000); // the blocked case has no later mutation to re-check on
    function applyKlarnaAmount(pl, holder) {
      if (nvKlarnaAmount === null) return;
      if (String(nvKlarnaAmount) === pl.getAttribute('data-purchase-amount')) { nvKlarnaAsserts = 0; return; }
      if (nvKlarnaAsserts++ > 8) { holder.hidden = true; return; } // it will not hold — never show a wrong number
      pl.setAttribute('data-purchase-amount', String(nvKlarnaAmount));
      if (window.KlarnaThemeGlobals) window.KlarnaThemeGlobals.data_purchase_amount = nvKlarnaAmount;
      if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        try { window.Klarna.OnsiteMessaging.refresh(); } catch (e) {}
      } else {
        (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []).push({ eventName: 'refresh-placements' });
      }
    }
    function syncKlarna() {
      var holder = root.querySelector('.nv-pb__klarna');
      if (!holder) return;
      var pl = holder.querySelector('klarna-placement');
      if (!pl) return;
      if (nvGuardOn) { holder.hidden = true; return; } // MKT-109: a disputed price gets no instalment claim
      var amount = parseMoneyMinor(priceText());
      if (amount === null) { var v = currentVariant(); amount = v ? v.price : null; }
      if (amount === null) { holder.hidden = true; return; }
      // Quiet degrade: if Klarna's script never brings the placement alive (blocked,
      // failed), the empty tinted strip hides rather than sitting as bare chrome.
      if (pl.shadowRoot) holder.hidden = false;
      else if (Date.now() - nvKlarnaT0 > 10000) { holder.hidden = true; return; }
      if (amount !== nvKlarnaAmount) { nvKlarnaAmount = amount; nvKlarnaAsserts = 0; }
      if (!pl.hasAttribute('data-nv-klarna-watched')) {
        pl.setAttribute('data-nv-klarna-watched', '1');
        new MutationObserver(function () { applyKlarnaAmount(pl, holder); })
          .observe(pl, { attributes: true, attributeFilter: ['data-purchase-amount'] });
      }
      applyKlarnaAmount(pl, holder);
    }

    if (priceUI) {
      new MutationObserver(mirrorPrice).observe(priceUI, { childList: true, subtree: true, characterData: true });
    }

    // Fallback when the theme's price machinery is not running in this section:
    // if the mirrored node still shows nothing after load, write the variant list
    // price into it once. DPO overwrites it if it publishes a total there.
    window.addEventListener('load', function () {
      if (priceUI && !priceText()) {
        var v = currentVariant();
        var target = priceUI.querySelector('[data-price]') || priceUI;
        if (v) target.innerHTML = '<span class="money">' + formatMoney(v.price) + '</span>';
        mirrorPrice();
      }
    });

    /* ---------- variant-change from the theme keeps everything in sync ---------- */

    var variantSelection = formwrap && formwrap.querySelector('variant-selection');
    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (e) {
        var variant = e.detail && e.detail.variant;
        if (variant && variant.options) {
          variant.options.forEach(function (val, i) { chosen[i + 1] = val; });
          refreshUI();
        }
      });
    }

    /* ---------- DPO: wrap it, watch it, never rebuild it ---------- */

    var dpoSlot = root.querySelector('[data-nv-dpo-slot]');
    var dpoReady = false;

    function dpoLooksAlive() {
      if (!dpoSlot) return false;
      return !!dpoSlot.querySelector('select, input:not([type="hidden"]), textarea, .dpo-container');
    }

    function adoptDpoContainer() {
      // If the app rendered its container outside the slot (theme bindings),
      // MOVE the node in — never clone, never re-render.
      if (!dpoSlot) return;
      var container = document.querySelector('.dpo-container');
      if (container && !dpoSlot.contains(container)) dpoSlot.appendChild(container);
    }

    function onDpoInit() {
      dpoReady = true;
      adoptDpoContainer();
      if (specStep) specStep.hidden = false;
      var ans = specStep && specStep.querySelector('[data-nv-step-answer]');
      if (ans && dpoSlot) {
        dpoSlot.addEventListener('change', function () { ans.textContent = 'Your choices'; mirrorPrice(); });
      }
      // MKT-099: the app's field drives step 2's display — DPO emits no event of its own on
      // option change (measured 2026-09-01: only the native change bubbling from its select),
      // so a change listener on its own controls is the observation, per the MKT-073 precedent.
      if (dpoSlot && !dpoSlot.hasAttribute('data-nv-rgb-hooked')) {
        dpoSlot.setAttribute('data-nv-rgb-hooked', '1');
        dpoSlot.addEventListener('change', function () { refreshUI(); });
      }
      // MKT-082.3: the RGB signpost only appears when the app actually offers an RGB option
      var rgbBtn = root.querySelector('[data-nv-rgb-link]');
      if (rgbBtn && dpoSlot) {
        var hasRgb = Array.prototype.some.call(dpoSlot.querySelectorAll('select option'), function (o) {
          return RGB_RE.test(o.text);
        });
        if (hasRgb) rgbBtn.hidden = false;
      }
      refreshUI();
      mirrorPrice();
    }

    function hookDpoEvent(tries) {
      if (window.jQuery) {
        window.jQuery(window).on('dpo_initialized', onDpoInit);
        // The app can fire before this hook attaches — catch up if it already rendered.
        if (dpoLooksAlive() || document.querySelector('.dpo-container')) onDpoInit();
      } else if (tries > 0) {
        setTimeout(function () { hookDpoEvent(tries - 1); }, 250);
      }
    }

    if (specStep) {
      hookDpoEvent(40); // jQuery is deferred; retry for up to ~10s

      // If the app (re)places its container outside the slot at any point, move it back in.
      new MutationObserver(function () {
        var container = document.querySelector('.dpo-container');
        if (container && dpoSlot && !dpoSlot.contains(container)) onDpoInit();
      }).observe(root, { childList: true, subtree: true });

      setTimeout(function () {
        if (!dpoReady && !dpoLooksAlive() && !document.querySelector('.dpo-container')) {
          // Fail safe: the app never appeared. Hide step 3; buying still works.
          specStep.hidden = true;
          refreshUI();
        }
      }, data.dpoTimeoutMs || 6000);
    }

    /* ---------- MKT-082.3 + MKT-099: RGB signpost — opens step 3, points at Type of LED,
       and (MKT-099) selects/clears the app's colour-changing option through the app's own
       control so its handlers run and its price updates. Never changes the Shopify variant.
       If the field cannot be reached, opening + highlighting is the whole action (H3). ---------- */
    var rgbLink = root.querySelector('[data-nv-rgb-link]');
    if (rgbLink) {
      rgbLink.addEventListener('click', function () {
        if (!specStep || specStep.hidden) return;
        openStep(specStep);
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        specStep.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        var target = null;
        if (dpoSlot) {
          var selects = Array.prototype.filter.call(dpoSlot.querySelectorAll('select'), function (s) { return s.offsetParent !== null; });
          target = selects.find(function (s) {
            var label = null, n = s.parentElement;
            for (var i = 0; i < 4 && n && !label; i++) { label = n.querySelector('label'); n = n.parentElement; }
            return label && /type of led/i.test(label.textContent);
          }) || selects[0];
        }
        if (target) {
          target.classList.add('nv-dpo-highlight');
          setTimeout(function () { target.classList.remove('nv-dpo-highlight'); }, 2400);
        }
        setLedRgb(!rgbActive()); // MKT-099: pressed = on; pressing again turns it back off
      });
    }

    /* ---------- MKT-093.2: sticky buy column offset ----------
       top = the header's sticky height + 12px, read from the header itself (the announcement
       bar above it scrolls away, so the offset tracks the header, not the bar). The header
       only counts if it can actually pin: sticky with room to move inside its parent, or a
       sticky/fixed section wrapper. If the column is taller than the viewport, top goes
       below zero so the column scrolls to its end before pinning (bottom-pin) — a naive
       top-pin would leave Add to cart unreachable. Re-measured on resize and whenever the
       column's height changes (steps opening, DPO revealing fields). Two-column grid only: below
       1200px (MKT-096.1) the column stacks full width and there is nothing to pin. */
    var buyCol = root.querySelector('.nv-pb__buy');
    function pinnedHeaderHeight() {
      var hdr = document.querySelector('.nv-header-wrapper');
      if (!hdr) return 0;
      var hs = getComputedStyle(hdr), h = hdr.getBoundingClientRect().height;
      if (hs.position === 'fixed') return h;
      var parent = hdr.parentElement, sec = hdr.closest('.shopify-section');
      if (hs.position === 'sticky' && parent && parent.getBoundingClientRect().height - h > 1) return h;
      if (sec && /^(sticky|fixed)$/.test(getComputedStyle(sec).position)) return sec.getBoundingClientRect().height;
      return 0;
    }
    function setBuyTop() {
      if (!buyCol) return;
      if (!window.matchMedia('(min-width: 1200px)').matches) { buyCol.style.removeProperty('--nv-buy-top'); return; }
      var top = Math.round(pinnedHeaderHeight() + 12);
      var vh = window.innerHeight, colH = buyCol.getBoundingClientRect().height;
      if (colH + top + 12 > vh) top = Math.round(vh - colH - 12);
      buyCol.style.setProperty('--nv-buy-top', top + 'px');
      buyCol.setAttribute('data-nv-buy-top', top);
    }
    if (buyCol) {
      setBuyTop();
      window.addEventListener('resize', setBuyTop);
      window.addEventListener('load', setBuyTop);
      if ('ResizeObserver' in window) new ResizeObserver(setBuyTop).observe(buyCol);
    }

    /* ---------- sticky mobile bar ---------- */

    var buyRow = formwrap && formwrap.querySelector('.purchase-details');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var mobile = window.matchMedia('(max-width: 1199px)').matches; // the stacked layout (MKT-096.1)
        sticky.hidden = !(mobile && !visible);
      }, { threshold: 0 }).observe(buyRow);

      var stickyAdd = sticky.querySelector('[data-nv-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () {
        var realBtn = formwrap.querySelector('button[name="add"]');
        if (realBtn) realBtn.click(); // the real submit — DPO validation included
      });
    }

    /* ---------- accordions ---------- */

    root.querySelectorAll('[data-nv-acc]').forEach(function (row) {
      var btn = row.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = row.classList.toggle('nv-acc__row--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // fill the sizes-table dimensions cells from the dims map (no data -> empty cell)
    root.querySelectorAll('[data-nv-dims-for]').forEach(function (td) {
      var d = dimEntry(td.getAttribute('data-nv-dims-for'));
      if (d) td.textContent = d.text;
    });

    // MKT-080.2/3: dimensions and split flags on the size chips — only from real data
    root.querySelectorAll('[data-nv-step-kind="size"] [data-nv-chip]').forEach(function (chip) {
      var value = chip.getAttribute('data-nv-value');
      var d = dimEntry(value);
      var dimsEl = chip.querySelector('[data-nv-chip-dims]');
      if (dimsEl && d) { dimsEl.textContent = d.text; dimsEl.hidden = false; }
      var flagEl = chip.querySelector('[data-nv-chip-flag]');
      if (flagEl && d && d.split) flagEl.hidden = false;
    });

    /* ---------- make sure the theme's own controller ran ----------
       The theme initialises sections with a js* class at document-ready, but
       Shopify.theme.jsProduct is sometimes defined too late — leaving the price
       stuck at .price-ui--loading (opacity 0) and the gallery without flickity.
       If, after the theme has had first go, the section is still uninitialised,
       initialise it ourselves. Skips whenever the theme already did the work. */
    function themeInitDone() {
      var wrapper = root.closest('.shopify-section');
      if (!wrapper) return true;
      var galleryOk = !wrapper.querySelector('.product-gallery__main') ||
        wrapper.querySelector('.product-gallery__main.flickity-enabled, .product-gallery__main.vertical-slider-enabled');
      var priceOk = !wrapper.querySelector('.price-ui--loading');
      return !!(galleryOk && priceOk);
    }
    var initTries = 0;
    function initTick() {
      if (themeInitDone() || initTries++ > 40) return;
      if (window.jQuery && window.Shopify && Shopify.theme && Shopify.theme.jsProduct) {
        try { Shopify.theme.jsProduct.init(window.jQuery(root.closest('.shopify-section'))); } catch (e) {}
      }
      setTimeout(initTick, 300);
    }
    setTimeout(initTick, 400); // let the theme's own document-ready pass go first

    /* ---------- seed initial state ---------- */

    (data.options || []).forEach(function (o) {
      var v = readNativeChoice(o.position);
      if (v) chosen[o.position] = v;
    });
    if (!Object.keys(chosen).length) {
      var first = (data.variants || [])[0];
      if (first) first.options.forEach(function (val, i) { chosen[i + 1] = val; });
    }
    refreshUI();
    setTimeout(mirrorPrice, 800);
  });
})();
